import React, { useState } from 'react';
import AppDrawer from './AppDrawer';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

const AppDrawerContainer = () => {
  const { data: uiDetails } = useQuery('/admin/uidetails', {
    refetchInterval: 1000, // Set the refetch interval to 1000 milliseconds
  });
  const { data: menuData } = useQuery('/admin/menu');
  const isAppDrawerOpen = useSelector((state) => state.commonStates.isAppDrawerOpen);
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [activeMobileSectionIndex, setActiveMobileSectionIndex] = useState('');
  const handleOnSectionClick = (index) => {
    setActiveSectionIndex(index);
  };
  const handleOnMobileSectionClick = (index) => {
    if (activeMobileSectionIndex === index) {
      setActiveMobileSectionIndex('');
    } else {
      setActiveMobileSectionIndex(index);
    }
  };

  return (
    <AppDrawer
      activeSectionIndex={activeSectionIndex}
      activeMobileSectionIndex={activeMobileSectionIndex}
      isAppDrawerOpen={isAppDrawerOpen}
      onSectionClick={handleOnSectionClick}
      onMobileSectionClick={handleOnMobileSectionClick}
      uiDetails={uiDetails}
      menuData={menuData}
    />
  );
};
export default AppDrawerContainer;
